import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { NewsroomHighlightTemplate } from "./highlight-block.templates";

export default {
    title: "Website/Partial Templates/Newsroom Blocks/Highlight Block (C.24)",
    render: NewsroomHighlightTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        title: "Highlight Topic Lorem ipsum Dolor",
        icon: "globe",
        ctaText: "Mehr erfahren",
        ctaLink: "#",
    },
};

export const Default = {};
